module.exports = __webpack_public_path__ + "static/img/kefu.c96d80b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kefu.png
// module id = KGy/
// module chunks = 1